__turbopack_context__.v({
  "is-active": "MobileNavigation-module-scss-module__1X5rka__is-active",
  "link": "MobileNavigation-module-scss-module__1X5rka__link",
  "menu-item": "MobileNavigation-module-scss-module__1X5rka__menu-item",
  "menu-item-list": "MobileNavigation-module-scss-module__1X5rka__menu-item-list",
  "mobile-menu": "MobileNavigation-module-scss-module__1X5rka__mobile-menu",
  "not-active": "MobileNavigation-module-scss-module__1X5rka__not-active",
  "settings-link": "MobileNavigation-module-scss-module__1X5rka__settings-link",
  "sign-up-button": "MobileNavigation-module-scss-module__1X5rka__sign-up-button",
  "sign-up-menu-item": "MobileNavigation-module-scss-module__1X5rka__sign-up-menu-item",
  "slide-in": "MobileNavigation-module-scss-module__1X5rka__slide-in",
  "slide-out": "MobileNavigation-module-scss-module__1X5rka__slide-out",
  "user-avatar": "MobileNavigation-module-scss-module__1X5rka__user-avatar",
  "user-email": "MobileNavigation-module-scss-module__1X5rka__user-email",
  "user-info": "MobileNavigation-module-scss-module__1X5rka__user-info",
});
